module.exports = __webpack_public_path__ + "static/media/logo-cs.4ac1db1b.jpeg";